module.exports = __webpack_public_path__ + "assets/img/12.49ff907e.svg";